import { HttpService, HttpServiceResponse } from '../shared'
import { UserConfigServerData } from './userConfig.types'

export class UserConfigProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public get(): Promise<HttpServiceResponse<UserConfigServerData>> {
    return this.http.post(`${this.url}/user_config_view_api.php`)
  }

  public set(key: string, value: string | number): Promise<HttpServiceResponse<unknown>> {
    return this.http.post(`${this.url}/user_config_oper_api.php?ConfTitle=${key}&ConfValue=${value}`)
  }

  public refresh(): Promise<HttpServiceResponse<unknown>> {
    return this.http.post(`${this.url}/user_config_oper_api.php?action=refresh`)
  }
}
